export default {
  processes: 0,
  navProcesses: 0,
};
